import { Authenticator, useAuthenticator, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';

type LocationProps = {
    state: {
        from: Location;
    };
};

export const Login = () => {
    const { authStatus } = useAuthenticator(context => [context.authStatus]);
    const location = useLocation() as LocationProps;
    const navigate = useNavigate();
    const from = location.state?.from?.pathname || '/';
    const attempted = useRef(false);

    useEffect(() => {
        if (authStatus === 'authenticated') {
            navigate(from, { replace: true });
            return;
        }

        if (authStatus === 'unauthenticated' && !attempted.current) {
            attempted.current = true;
            signInWithRedirect({ provider: { custom: 'AzureAD' } });
        }
    }, [authStatus, navigate, from]);

    return (
        <View className="auth-wrapper">
            <Authenticator hideSignUp />
        </View>
    );
};
